// React core
// ----------------------
// ✅ React & Core Libraries
// ----------------------
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ----------------------
// ✅ Contexts & Utils
// ----------------------
import { useWebSocket } from '../../../context/WebSocketContext.jsx';
import axios from '../../../axiosInstance.js';

// ----------------------
// ✅ Icons (MUI & Lucide)
// ----------------------
import {
    LocalShippingOutlined as LocalShippingOutlinedIcon,
    Article as ArticleIcon,
    NetworkWifi as NetworkWifiIcon,
    MyLocation as MyLocationIcon,
    SocialDistance as SocialDistanceIcon,
    NotInterested as NotInterestedIcon,
    Close,
} from '@mui/icons-material';

import { X, WifiHigh, Phone, Info } from 'lucide-react';

// ----------------------
// ✅ External Libraries
// ----------------------
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import { motion, AnimatePresence, useMotionValue, useTransform } from 'framer-motion';

// ----------------------
// ✅ Images
// ----------------------
import search from '../../../Assets/home2/search.svg';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png';
import icon6 from '../../../Assets/crane/icon6.svg';
import icon7 from '../../../Assets/crane/icon7.svg';
import icon11 from '../../../Assets/crane/icon11.svg';
import icon18 from '../../../Assets/crane/icon18.svg';
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import img2 from '../../../Assets/add/img2.png';
import img3 from '../../../Assets/add/img3.png';
import assignedTask from '../../../Assets/assignedTask.png';
import comingCrane from '../../../Assets/comingCrane.png';
import checksuccess from '../../../Assets/checksuccess.png';
import crossUser from '../../../Assets/crossUser.png';
import filterUser from '../../../Assets/filterUser.png';
import telephonecall from '../../../Assets/telephonecall.png';
import mediumCraneImage from '../../../Assets/crane/mediumCrane.jpg';
import miniRecoveryVanImage from '../../../Assets/crane/miniRecoveryVan.jpg';
import frontLeft from '../../../Assets/crane/front-left.jpg';

// ----------------------
// ✅ Components
// ----------------------
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx';
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import ModalButton from '../../Customers/FirstPageDesigns/ModalButton.jsx';
import RatingModal from '../../Customers/VendorResponsesCustomer/RatingModal.jsx';
import CraneFirstPage from '../../Customers/VendorResponsesCustomer/CraneFirstPage.jsx';
import SuccessMessage from '../../Customers/VendorResponsesCustomer/SuccessMessage.jsx';
import OLAMapsForDriverLocation from '../../../Component/Customers/OLAMapsForDriverLocation.jsx';
import MapForVendorDistance from '../../Customers/Map/MapForVendorDistance.jsx';
import ShowVehicleInspectionFlow from '../../Customers/FirstPageDesigns/VehicleInspectionFlow.jsx';

// ----------------------
// ✅ CSS
// ----------------------
import '../../Customers/FirstPageDesigns/FirstPage.css';


const toRad = deg => deg * (Math.PI / 180);

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function VendorDriverAllotedCase({ incomingData, onActionComplete }) {

    console.log('incomingData?.dropLatitude', incomingData)
    const navigate = useNavigate()
    const { messages } = useWebSocket();
    const { state } = useLocation();
    const [currentStage, setCurrentStage] = useState([]); // Example stage
    console.log("currentStage123", currentStage)
    const [isImageContainerVisible, setIsImageContainerVisible] = useState(false);
    const [data, setData] = useState([]);
    const [dummyData, setDummyData] = useState([]);
    const [currentItems, setCurrentItems] = useState(data);
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [selectedAction, setSelectedAction] = useState(null)
    const [alertMessage, setAlertMessage] = useState(null);
    const [currentItem, setCurrentltem] = useState(null);


    const [driverLocation, setDriverLocation] = useState(() => {
        const stored = localStorage.getItem('driverLocation');
        console.log('driverlocation 1', stored)
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                return {
                    lat: parseFloat(parsed.lat),
                    lng: parseFloat(parsed.lng),
                };
            } catch (err) {
                console.error("Failed to parse driver location:", err);
                return null;
            }
        }
        return null;
    });


    const [dropLocation, setDropLocation] = useState(null);
    console.log('driverLocation current 123', driverLocation)
    const [showPopup, setShowPopup] = useState(false);
    const callContainerRef = useRef(null);

    const [loadingReady, setLoadingReady] = useState(false);
    const [loadingReached, setLoadingReached] = useState(false);
    const [loadingDone, setLoadingDone] = useState(false);

    const [alertType, setAlertType] = useState(null);
    const [distance, setDistances] = useState([])
    console.log("distacneeerwerw", distance)
    const [avg, setAvg] = useState([])
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [isWithinRange, setIsWithinRange] = useState(false)

    const [filter, setFilter] = useState('')
    const [doneFetching, setDoneFetching] = useState(false)

    const [isExpanded, setIsExpanded] = useState(true);
    const [expandedIndex, setExpandedIndex] = useState(0);
    console.log('expanded', expandedIndex)
    const toggleSheet = (index) => {
        setExpandedIndex(index)
        setIsExpanded(prev => !prev);
    };
    const y = useMotionValue(0); // drag distance
    const sheetRef = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (callContainerRef.current && !callContainerRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleDragEnd = (_, info) => {
        const offset = info.offset.y;
        const velocity = info.velocity.y;

        // Decide based on drag distance or speed
        if (offset > 100 || velocity > 500) {
            setIsExpanded(false); // collapse
        } else {
            setIsExpanded(true); // expand
        }
    };


    console.log("avg", avg)
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const currentService = localStorage.getItem("currentService")
    const [deletedVehicleOrder, setDeletedVehicleOrder] = useState(null)
    const stages = [
        { label: "assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png' },
        { label: "moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png' },
        { label: "reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' },
    ];


    console.log('isImageContainer', isImageContainerVisible)
    const updateDriverLocation = (lat, lng) => {
        console.log('lat.long before', lat, lng, typeof lat, typeof lng)
        const location = { lat: parseFloat(lat), lng: parseFloat(lng) };
        console.log('lat.long before', location.lat, location.lng, typeof location.lat, typeof location.lng)
        setDriverLocation(location);
        console.log('driverlocation 2', location)

        localStorage.setItem('driverLocation', JSON.stringify(location));
    };

    useEffect(() => {
        setData(incomingData)
        setDummyData(incomingData)
        console.log('incoling', incomingData)
        console.log("incomingData[0]?.approvedRightlyMeasured && incomingData[0].otp && incomingData[0]?.otpByCustomer == null", incomingData[0]?.approvedRightlyMeasured && incomingData[0].otp && incomingData[0]?.otpByCustomer == null)
        if (incomingData[0]?.approvedRightlyMeasured && incomingData[0].otp && incomingData[0]?.otpByCustomer == null) {
            setIsModalOpenForOTP(true);
        }
        if (incomingData[0]?.issue_occured) {
            setIsIssueModalOpen(true);
        }
        console.log("seTDATIOATN", incomingData);
        setDoneFetching(true)
        setCurrentItems(incomingData);
        console.log('updating locaiton 1')
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                updateDriverLocation(position.coords.latitude, position.coords.longitude);
            });
        } else {
            updateDriverLocation(parseFloat(incomingData[0].driverLatitude), parseFloat(incomingData[0].driverLongitude));
        }
        console.log('location 3', incomingData[0].driverLatitude, incomingData[0].driverLongitude)
        setIsWithinRange((driverLocation && incomingData[0]) ? getDistanceFromLatLonInKm(
            incomingData[0].driverLatitude,
            incomingData[0].driverLongitude,
            parseFloat(incomingData[0].dropLatitude),
            parseFloat(incomingData[0].dropLongitude)
        ) <= 1 : false);
        if (messages.length > 0) {
            messages.forEach((message) => {
                console.log("messages123 vendordriveralloted", message)
                if (message.forPage === 'crane-user-all-cases') {
                    onActionComplete?.();
                }
                else if (message.forPage === "updated-location") {
                            console.log("***********************WebSocket messages received: vendor", messages);
                    console.log('📍 Driver location update', message);
                    console.log('updating locaiton 2')

                    updateDriverLocation(parseFloat(message.lat), parseFloat(message.lng));
                    setDriverLocation({ lat: message.lat, lng: message.lng });
                    console.log('location 4', message.lat, message.lng)
                    setIsWithinRange((driverLocation && data[0]) ? getDistanceFromLatLonInKm(
                        message.lat,
                        message.lng,
                        parseFloat(data[0].dropLatitude),
                        parseFloat(data[0].dropLongitude)
                    ) <= 1 : false);
                }
            })
            messages.length = 0;
        }

        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }

    }, [token, userId, navigate, messages]);


    useEffect(() => {
        if (driverLocation && dropLocation) {
            const distance = getDistanceFromLatLonInKm(
                driverLocation.lat,
                driverLocation.lng,
                dropLocation.lat,
                dropLocation.lng
            );
            console.log("📏 Distance to drop:", distance);
            setIsWithinRange(distance <= 1);
        }
    }, [driverLocation, dropLocation]);

    // const fetchAllowedToDriver = async () => {
    //     try {
    //         setDoneFetching(false)
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/fetchAllowedToDriver/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
    //         console.log("Total assignedTasksMechanic", response.data.data);
    //         setData(response.data.data)
    //         setDummyData(response.data.data)
    //         console.log("seTDATIOATN", response.data.data);
    //         console.log('response.data.data', response.data.data)
    //         console.log("response.data.data[0]?.approvedRightlyMeasured && response.data.data[0].otp && response.data.data[0]?.otpByCustomer == null", response.data.data[0]?.approvedRightlyMeasured && response.data.data[0].otp && response.data.data[0]?.otpByCustomer == null)
    //         if (response.data.data[0]?.approvedRightlyMeasured && response.data.data[0].otp && response.data.data[0]?.otpByCustomer == null) {
    //             setIsModalOpenForOTP(true);
    //         }
    //         if (response.data.data[0]?.issue_occured) {
    //             setIsIssueModalOpen(true);
    //         }
    //         setCurrentItems(response.data.data);
    //         setDropLocation({
    //             lat: response.data.data.dropLatitude,
    //             lng: response.data.data.dropLongitude
    //         });
    //         console.log('updating locaiton 3')

    //         console.log('response.data.data.driverLatitude', response.data.data[0].driverLatitude, typeof response.data.data[0].driverLatitude)
    //         console.log('response.data.data.driverLatitude', parseFloat(response.data.data[0].driverLatitude), typeof parseFloat(response.data.data[0].driverLatitude))

    //         updateDriverLocation(parseFloat(response.data.data[0].driverLatitude), parseFloat(response.data.data[0].driverLongitude));
    //         console.log('location 6', parseFloat(response.data.data[0].driverLatitude), parseFloat(response.data.data[0].driverLongitude))
    //         setDriverLocation({
    //             lat: parseFloat(response.data.data[0].driverLatitude),
    //             lng: parseFloat(response.data.data[0].driverLongitude),
    //         });
    //         setIsWithinRange((response.data.data) ? getDistanceFromLatLonInKm(
    //             parseFloat(response.data.data[0].driverLatitude),
    //             parseFloat(response.data.data[0].driverLongitude),
    //             parseFloat(response.data.data[0].dropLatitude),
    //             parseFloat(response.data.data[0].dropLongitude)
    //         ) <= 1 : false);
    //         setDoneFetching(true)

    //     } catch (error) {
    //         console.error("Failed to fetch assigned cases:", error);
    //     }
    // }

    const getData = async (accidentVehicleCode) => {
        console.log('helow', `${process.env.REACT_APP_BACKEND_URL}/api/getAssignedAccidentVehicleWithAccidentVehicleCode/${userId}/${accidentVehicleCode}`)
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getAssignedAccidentVehicleWithAccidentVehicleCode/${userId}/${accidentVehicleCode}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            setDoneFetching(true)
        }
        else {
            console.log('response123', response.data)
            console.log('esponse.data.data.completeOrde', response.data.data.completeOrder)
            if (response.data.data.completeOrder == true) {
                setTaskCompleted(true)
                sessionStorage.clear()
            }
            setData(response.data.data)
            setDummyData(response.data.data)
            console.log("seTDATIOATN", response.data.data);
            setDoneFetching(true)
            setCurrentItems(response.data.data);
        }
    };

    const goToMap = (item) => {
        console.log("itemfromgotomap", item)
        console.log("item.accidentLatitude", `${item?.[`${currentService}Details`].accidentLatitude}`, "item.accidentLongitude", item.accidentLongitude, "vendorCurrentLatitude", vendorCurrentLatitude, "vendorCurrentLongitude", vendorCurrentLongitude)
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: `${item?.[`${currentService}Details`].accidentLatitude}`,
                accidentLongitude: `${item?.[`${currentService}Details`].accidentLongitude}`,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: `${item?.[`${currentService}Details`].vehicleNo}`,
                fromPage: "statusTracking"
            }
        })
    }


    const vendorReached = async (item, action) => {
        console.log('items', item)
        console.log('items', `${item[`${currentService}Details`]?.AccidentVehicleCode}`)

        console.log('items2', `${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`)

        try {

            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                console.log("updated successfully")
                setSelectedAction(action)
                onActionComplete?.();
                // getData()
            }
            else console.log("there is some issue")

        }
        catch (error) {
            console.log("the error occured", error.message)
        }
    }

    const workDoneConfirmation = async (item, action) => {
        try {
            setCurrentltem(item)
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/workDoneConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                onActionComplete?.();
                // getData()
            } else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
            }

        }
        catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
    }





    console.log("{item?.customerAcceptedVendor", data[0]?.customerAcceptedVendor)
    console.log("disptan", data.length, doneFetching, distance.length, avg.length)

    const [isIssueModalOpen, setIsIssueModalOpen] = useState(false);
    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);
    const [reasonsForDrop, setReasonsForDrop] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState(null);

    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };

    const [errorMessage, setErrorMessage] = useState("");
    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];
    const [activeActionLoading, setActiveActionLoading] = useState(null); // values: 'readyToGo', 'reached', 'workdone'
    const [isLoading, setIsLoading] = useState(false);
    const [alreadyCancelled, setAlreadyCancelled] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [cancelled, setCancelled] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const cancelingOrder = async (currentItem) => {
        try {
            console.log('insoidre', currentItem)
            const reasons = [...selectedReasons, otherReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
            }
            console.log('i am here')
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem[`${currentService}Details`][`${currentService}`]}/${currentItem?.[`${currentService}Details`].vehicleNo}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedReasons, otherReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelContainerVisible(false);
                setReasonsForDrop(false);
                setCancelled(true)
                // getData()
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const cancleCaseProcedureFunc = (item) => {
        setCurrentltem(item)
        setIsCancelContainerVisible(true)
        setReasonsForDrop(false)
        // getVendorRating(item?.[`${currentService}Details`].crane)
        // getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }



    const allowDriver = async (item) => {
        try {
            setLoadingReady(true);
            setActiveActionLoading("allowDriver");

            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/allowDriver/${userId}/${item.AccidentVehicleCode}/${item.vendorType}`)
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/allowDriver/${userId}/${item.AccidentVehicleCode}/${data[0].vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                console.log('successfully updated status')
                onActionComplete?.();
                setLoadingReady(false);
            }
            else console.log("there is some issue")
            setLoadingReady(false);

        }
        catch (error) {
            console.log("the error occured", error.message)
        }
        finally {
            setActiveActionLoading(null);
        }
    }

    const readyToGo = async (item) => {
        try {
            console.log('data', item)
            setLoadingReady(true);
            setActiveActionLoading("readyToGo");

            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/vendorMoved/${userId}/${item.AccidentVehicleCode}/${item.vendorType}`)
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorMoved/${userId}/${item.AccidentVehicleCode}/${item.vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                console.log('successfully updated status')
                onActionComplete?.();
                // setDriverLocation({ lat: item.driverLatitude, lng: item.driverLongitude });
                setLoadingReady(false);
            }
            else console.log("there is some issue")
            setLoadingReady(false);

        }
        catch (error) {
            console.log("the error occured", error.message)
        }
        finally {
            setActiveActionLoading(null);
        }
    }

    const reachedLocation = async (item) => {
        try {
            setActiveActionLoading("reachedLocation");
            setLoadingReached(true);
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedLocation/${userId}/${item.AccidentVehicleCode}/${userId}/${item.vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                onActionComplete?.();
                setLoadingReached(false);
            } else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
                setLoadingReached(false);
            }
        } catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
        finally {
            setActiveActionLoading(null);
        }

        setTimeout(() => {
            setAlertMessage(null);
        }, 5000);
    };

    const sendOTP = async (item) => {
        try {
            setActiveActionLoading("sendOTP");
            setLoadingReached(true);
            let response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/vendorOTPValidation/${userId}/${item.AccidentVehicleCode}/${userId}/${item.vendorType}`,
                { otp: otp }, // ✅ correct way to send data
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );


            console.log("response.data.status12345", response.data)
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                onActionComplete?.();
                setLoadingReached(false);
            } else if (response.data.status == false) {
                setAlertMessage("Wrong OTP");
                setAlertType("danger"); // Bootstrap alert type for success
                setLoadingReached(false);
            }
            else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
                setLoadingReached(false);
            }
        } catch (error) {
            setAlertMessage("Wrong OTP");
            setAlertType("danger"); // Bootstrap alert type for success
        }
        finally {
            setActiveActionLoading(null);
        }

        setTimeout(() => {
            setAlertMessage(null);
        }, 5000);
    };


    const workDone = async (item) => {
        try {
            setLoadingDone(true);
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/VendorWorkDone/${userId}/${item.AccidentVehicleCode}/${item.vendorType}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                onActionComplete?.();
                setLoadingDone(false);
            }
            else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
                setLoadingDone(false);
            }
        }
        catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
        finally {
            setActiveActionLoading(null);
        }

    }

    const [isLoadingLoader, setIsLoadingLoader] = useState(false);
    const [TaskCompletedDone, setTaskCompleted] = useState(false);

    const [buttonLoader, setButtonLoader] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userRating, setUserRating] = useState(null);
    const [userItem, setUserItem] = useState(null);

    const handleRatingSubmit = (rating) => {

        setUserRating(rating);

        console.log("User selected rating:", rating);

        workDoneConfirmation(userItem.item, userItem.action)
    };

    const handleCancelRating = () => {
        console.log("User canceled the rating.");
        workDoneConfirmation(userItem.item, userItem.action)
    };

    const callRatingAndWorkDoneConfirmation = (item, action) => {

        // return
        setIsModalOpen(true)
        setUserItem({ item: item, action: action, })
    }

    useEffect(() => {
        if (isExpanded) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isExpanded]);

    const handleAction = async (itemId, actionType) => {
        const key = `${itemId}_${actionType}`;
        setButtonLoader(prev => ({ ...prev, [key]: true }));

        try {
            // Simulate API call
            if (actionType === "reached") {
                await vendorReached(itemId, true);
            } else if (actionType === "notReached") {
                await vendorReached(itemId, false);
            }
            else if (actionType === "workdone") {
                await workDoneConfirmation(itemId, true);
                // navigate('/customer-home-page')
            }
            else if (actionType === "notworkdone") {
                await workDoneConfirmation(itemId, true);
            }
            // Add other actions like "accept", "reject", etc. as needed
        } catch (error) {
            console.error(error);
        } finally {
            setButtonLoader(prev => ({ ...prev, [key]: false }));
        }
    };


    const [openDetails, setOpenDetails] = useState(false)
    const [otp, setOtp] = useState("");
    const inputRef = useRef(null);
    const [isModalOpenForOTP, setIsModalOpenForOTP] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 6); // Only digits, max 6
        setOtp(value);
    };

    const handleClick = () => {
        inputRef.current?.focus();
    };

    const isValidCoordinate = (coord) =>
        typeof coord === 'number' && !isNaN(coord);


    useEffect(() => {
        if (isModalOpenForOTP) {
            setTimeout(() => inputRef.current?.focus(), 100);
        }
    }, [isModalOpenForOTP]);


    return (
        <>



            <div >

                {data.length > 0 && doneFetching === true && (
                    <div>

                        {data.map((item, index) => (
                            item?.completeOrder && (<div
                                className="font-satoshi fixed  inset-0 z-[999] bg-black/40 flex px-4 items-top justify-center"
                            >
                                <div className="relative w-full h-[8rem] max-w-md bg-white text-gray-800 rounded-2xl shadow-2xl pt-2 mt-3 p-2 border border-gray-200 animate-fadeIn">
                                    <button
                                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
                                    >
                                        <Close size={20} />
                                    </button>

                                    <div className="flex gap-2 items-center text-center space-y-3">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-10 w-10 text-green-500"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M9 13h6m2 6H7a2 2 0 01-2-2V7a2 2 0 012-2h4l2-2h2l2 2h4a2 2 0 012 2v10a2 2 0 01-2 2z"
                                            />
                                        </svg>

                                        <h2 className="text-lg font-semibold text-green-600">Order Completed</h2>
                                    </div>
                                    <p className="text-sm text-gray-600">
                                        The order of vehicle is completed.
                                    </p>
                                </div>
                            </div>)))}
                        <motion.div
                            ref={sheetRef}
                            initial={{ y: 300 }}
                            animate={{ y: isExpanded ? 0 : -1 }}
                            transition={{
                                type: "spring",
                                stiffness: 200,
                                damping: 25,
                                duration: 0.5,
                                delay: 0.3
                            }}
                            style={{
                                borderTopLeftRadius: "1rem",
                                borderTopRightRadius: "1rem",
                                touchAction: "none",
                                zIndex: 1001,
                                ...(isExpanded && { height: '98vh' }),
                                boxShadow: '-2px -3px 20px'
                            }}
                            className="fixed left-0 right-0 bottom-0 z-10 bg-white shadow-xl rounded-t-xl"
                        >


                            <div className="pt-2 pb-1 ml-1 mr-1">
                                {!isExpanded && data.map((item, index) => (
                                    <div style={{ boxShadow: '-3px -2px 20px', marginBottom: '0.2rem', borderRadius: '1rem' }}>
                                        <div onClick={() => toggleSheet(index)} className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-1" />
                                        <div key={index} onClick={() => toggleSheet(index)} className='flex items-center justify-between gap-[0.5rem] px-2'>
                                            <img src={item?.vendorType == "crane" ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/miniRecoveryVan.jpg'} className="h-[31px] w-[30px]" alt="" />
                                            <p className='font-satoshi font-bold font-sm'>{item.reg}</p>
                                            <button className="w-fit  rounded-[12px] flex items-center font-satoshi text-[12px] font-[500]  gap-[6px] md:hidden">
                                                {parseFloat(item?.fromVendorLocationToPickDistance || 0).toFixed(2)} Km
                                            </button>

                                            <div className="flex items-center ml-[4px] md:hidden">
                                                <WifiHigh className='h-[30px] w-[30px] text-green-500' />
                                                <span className='font-satoshi text-[14px] animate-pulse ml-[5px] px-[4px] rounded-[10px] font-bold text-blue-600'>
                                                    {Boolean(!item?.customerAcceptedVendor) && <span>Waiting...</span>}
                                                    {Boolean(!item?.vendorMoved && item?.customerAcceptedVendor) && <span>Accepted</span>}
                                                    {Boolean(item?.vendorMoved && !item?.vendorReached) && <span>On the way</span>}
                                                    {Boolean(item?.vendorReached && !item?.approvedReaching) && <span>Reached</span>}
                                                    {Boolean(item?.vendorReached && item?.approvedReaching) && <span>Confirmed</span>}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {isExpanded && expandedIndex !== null && (
                                    <div className='flex flex-col'>
                                        {(() => {
                                            const item = data[expandedIndex]
                                            return (
                                                <>
                                                    <div className="flex justify-end px-1 py-1">
                                                        <button onClick={() => setIsExpanded(false)}>
                                                            <X className="w-6 h-6 text-gray-700" />
                                                        </button>
                                                    </div>
                                                    {driverLocation !== null && (
                                                        <div
                                                            style={{ position: "relative" }}
                                                            className={`relative w-full ${isExpanded ? 'h-[calc(100vh-16em)]' : 'h-[100vh]'}`}
                                                        >
                                                            <OLAMapsForDriverLocation
                                                                dropLatitude={item?.dropLatitude}
                                                                dropLongitude={item?.dropLongitude}
                                                                pickupLatitude={item?.pickupLatitude}
                                                                pickupLongitude={item?.pickupLongitude}
                                                                allowDriverProceed={item?.allowDriverProceed}
                                                                driverLatitude={driverLocation?.lat}
                                                                driverLongitude={driverLocation?.lng}
                                                                showFullHeight={true}
                                                                driverOnTheWayDestination={item?.otpByCustomer !== null ? true : false}
                                                            />
                                                        </div>)}

                                                    <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] relative ms:px-[40px] px-[20px] rounded-[12px]">

                                                        <div className="flex md:flex-row flex-col justify-between items-center  md:gap-0 gap-[20px]">
                                                            <div className='flex items-center w-full justify-between'>
                                                                <div className='flex gap-[0.5rem]'>
                                                                    {/* <img src={item?.vendorType == "crane" ? mediumCraneImage : miniRecoveryVanImage} className="h-[31px] w-[40px]" alt="" /> */}

                                                                    <button className='w-fit bg-[#000000] rounded-[12px] px-[9px] py-[4px] flex items-center font-satoshi text-[12px] font-[500] text-[#FFFFFF] gap-[6px] md:hidden'>
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon18.svg' className='h-[20px] w-[20px]' alt="" />
                                                                        {parseFloat(item?.fromPickToDropDistance || 0).toFixed(2)} Km
                                                                    </button>
                                                                </div>

                                                                <div className="flex items-center ml-[4px] md:hidden">
                                                                    <WifiHigh className='h-[30px] w-[30px] mb-[0.5rem] text-green-500' />
                                                                    <span className='font-satoshi text-[14px] animate-pulse ml-[5px] px-[4px] rounded-[10px] font-bold text-blue-600'>
                                                                        {Boolean(!item?.customerAcceptedVendor) && <span>Waiting...</span>}
                                                                        {Boolean(!item?.vendorMoved && item?.customerAcceptedVendor) && <span>Accepted</span>}
                                                                        {Boolean(item?.vendorMoved && !item?.vendorReached) && <span>On the way</span>}
                                                                        {Boolean(item?.vendorReached && !item?.approvedReaching) && <span>Reached</span>}
                                                                        {Boolean(item?.vendorReached && item?.approvedReaching) && <span>Confirmed</span>}
                                                                    </span>
                                                                </div>
                                                                <div className="font-satoshi relative inline-block" ref={callContainerRef}>
                                                                    {showPopup && (
                                                                        <div className="absolute top-10 right-10 bg-white border rounded shadow-md p-3 z-50 w-[40vw]">
                                                                            <p className="text-sm mb-2 text-gray-700">Need help?</p>
                                                                            <a
                                                                                href="tel:+917800784700"
                                                                                className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                                            >
                                                                                <Phone size={20} className='text-blue-400 font-bold' />
                                                                                <p className='text-blue-500 font-bold font-400'>Call Us</p>
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                    <button
                                                                        className="text-blue-500 hover:text-blue-700"
                                                                        onClick={() => setShowPopup((prev) => !prev)}
                                                                    >
                                                                        <Info size={24} />
                                                                    </button>


                                                                </div>
                                                                {/* <button className='mr-[1rem] mt-1' onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}><img src={icon6} className='h-[1.5rem] w-[1.5rem]' alt="phone" /></button> */}

                                                            </div>


                                                        </div>
                                                        <hr className='1px solid red m-[0.5rem]' />


                                                        <div className="h-full w-full rounded-xl overflow-hidden mt-1" onClick={() => { goToMap(item) }}>
                                                            <MapForVendorDistance state={{ fromPage: 'statusTracking' }} />

                                                        </div>
                                                        <div>
                                                            <div className="flex md:flex-row flex-col items-start">
                                                                <div className="flex sm:flex-col flex-row items-center justify-around w-full md:hidden">
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg' className="h-[4rem] w-[6rem]" alt="" />

                                                                    <div className='flex flex-col'>

                                                                        <div>
                                                                            <h6 className="m-0 font-[700] font-satoshi text-[12px] sm:text-[24px] text-[#0A0119] pb-[6px] flex justify-end">
                                                                                {item?.reg}
                                                                            </h6>

                                                                            <div className='flex gap-2 justify-end'>
                                                                                <p className="font-[500] flex m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]"><p>{item?.make}, {item?.model}</p> <span></span></p>
                                                                                <div className="relative inline-block group">
                                                                                    <img
                                                                                        src="https://upload.wikimedia.org/wikipedia/en/thumb/3/35/Information_icon.svg/1024px-Information_icon.svg.png"
                                                                                        className="h-[15px] w-[15px] cursor-pointer"
                                                                                        alt="info"
                                                                                    />

                                                                                    {/* Modal shown on hover */}
                                                                                    <div className="absolute right-full mr-2 top-1/2 -translate-y-1/2 z-[1002] hidden group-hover:flex flex-col gap-2 bg-white p-4 rounded-xl shadow-xl w-[250px]">
                                                                                        <div>
                                                                                            <h6
                                                                                                className={`font-[700] font-satoshi text-[13px] sm:text-[20px] text-[#0A0119] pb-[6px] whitespace-normal`}
                                                                                            >
                                                                                                {item?.pickupLocation}
                                                                                            </h6>
                                                                                            <p className="font-[500] font-satoshi text-[11px] sm:text-[16px] text-[#515151]">
                                                                                                Pickup Location
                                                                                            </p>
                                                                                        </div>

                                                                                        <div>
                                                                                            <h6
                                                                                                className={`font-[700] font-satoshi text-[13px] sm:text-[20px] text-[#0A0119] pb-[6px] whitespace-normal`}
                                                                                            >
                                                                                                {item?.dropLocation}
                                                                                            </h6>
                                                                                            <p className="font-[500] font-satoshi text-[11px] sm:text-[16px] text-[#515151]">
                                                                                                Drop Location
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>




                                                                        </div>
                                                                        <div className='sm:hidden'>
                                                                            {/* <p className="font-[500] m-0 mt-3 font-satoshi font-semibold text-[14px] sm:text-[16px] text-[#515151]">Reg on {item?.systemDate.split("T")[0]}</p> */}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='flex justify-between'>
                                                                    <div className="flex md:flex-row">
                                                                        <div className="hidden md:block">
                                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className="h-[100px] w-[100px]" alt="" />
                                                                        </div>

                                                                        <div className="grid sm:grid-cols-4 grid-cols-1 gap-[12px]">
                                                                            <div className="hidden md:block">
                                                                                <h6 className="m-0 font-[700] font-satoshi text-[18px] sm:text-[24px] text-[#0A0119] pb-[6px]">
                                                                                    {item?.reg}
                                                                                </h6>
                                                                                <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Vehicle No</p>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                            <div className='fixed bottom-0 left-0 w-full p-4 z-50 pt-0'>
                                                                <div className='flex gap-2 mt-1 justify-end'>
                                                                    {Boolean(!item?.customerAcceptedVendor && !item?.issue_occured) && (
                                                                        <button
                                                                            disabled
                                                                            className=" py-[5px] w-full text-center   rounded-xl font-satoshi font-[400] text-[16px] sm:text-[24px] leading-[33.6px] opacity-50 cursor-not-allowed"
                                                                        >
                                                                            Waiting for confirmation...
                                                                        </button>
                                                                    )}
                                                                    {/* {Boolean(!item?.paymentInitiated) && (
                                                                        <button
                                                                            disabled
                                                                            className=" py-[5px] w-full text-center   rounded-xl font-satoshi font-[400] text-[16px] sm:text-[24px] leading-[33.6px] opacity-50 cursor-not-allowed"
                                                                        >
                                                                            cancel
                                                                        </button>
                                                                    )} */}


                                                                    {Boolean(!item?.allowDriverProceed && item?.customerAcceptedVendor && !item.closeOrder && !item?.issue_occured) && (
                                                                        <p
                                                                            onClick={allowDriver}
                                                                            className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-[#21A6E9] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                        >
                                                                            {/* <KeyboardDoubleArrowRightIcon className="absolute left-2" /> */}
                                                                            Allow driver to proceed
                                                                        </p>
                                                                    )}


                                                                    {Boolean(!item?.vendorMoved && item.allowDriverProceed && !item.closeOrder && !item?.issue_occured) && (
                                                                        <p
                                                                            onClick={() => { readyToGo(item) }}
                                                                            className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-[#21A6E9] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                        >
                                                                            {/* <KeyboardDoubleArrowRightIcon className="absolute left-2" /> */}
                                                                            Ready To Go
                                                                        </p>
                                                                    )}



                                                                    {Boolean(item?.vendorMoved && !item?.vendorReached && !item?.approvedReaching && !item?.issue_occured) && (
                                                                        <p
                                                                            onClick={() => { reachedLocation(item) }}

                                                                            className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-[#21A6E9] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                        >
                                                                            Reached At Spot Location
                                                                            {/* <KeyboardDoubleArrowLeftIcon className="absolute right-2" /> */}
                                                                        </p>
                                                                    )}
                                                                    {/* Reached, waiting on customer to confirm via vendorReachedConfirmation */}
                                                                    {Boolean(item?.vendorReached && !item?.approvedReaching && !item?.issue_occured) && (
                                                                        <button
                                                                            disabled
                                                                            className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-gray-400 px-4 py-3 text-sm border border-gray-400 text-center rounded-full font-bold text-white flex items-center justify-center relative w-full opacity-70 cursor-not-allowed"
                                                                        >
                                                                            Waiting for customer to confirm you've reached...
                                                                        </button>
                                                                    )}

                                                                    {Boolean(item?.approvedReaching) && Boolean(!item?.approvedRightlyMeasured) && !item?.detailsFilledAt && (
                                                                        <ShowVehicleInspectionFlow accidentVehicleCode={item.AccidentVehicleCode} vendorType={item.vendorType}> </ShowVehicleInspectionFlow>
                                                                    )}
                                                                    {Boolean(item?.approvedReaching) &&
                                                                        Boolean(!item?.approvedRightlyMeasured) &&
                                                                        Boolean(item?.detailsFilledAt) && (
                                                                            <button
                                                                                    disabled
                                                                                    className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-gray-400 px-4 py-3 text-sm border border-gray-400 text-center rounded-full font-bold text-white flex items-center justify-center relative w-full opacity-70 cursor-not-allowed"
                                                                            >
                                                                                Waiting for customer to confirm vehicle details...
                                                                            </button>
                                                                    )}


                                                                    {Boolean(item?.approvedRightlyMeasured && item.otp && item?.otpByCustomer == null && !item?.issue_occured) && (
                                                                        <div>
                                                                            {/* Trigger Button */}
                                                                            <button
                                                                                className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-[#21A6E9] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                                onClick={() => setIsModalOpenForOTP(true)}
                                                                            >
                                                                                Please Input OTP
                                                                            </button>

                                                                            {/* OTP Modal */}
                                                                            <AnimatePresence>

                                                                                {isModalOpenForOTP && (
                                                                                    <motion.div
                                                                                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                                                                        initial={{ opacity: 0 }}
                                                                                        animate={{ opacity: 1 }}
                                                                                        exit={{ opacity: 0 }}
                                                                                        onClick={() => inputRef.current?.focus()}
                                                                                    >
                                                                                        <motion.div
                                                                                            className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                                                                            initial={{ scale: 0.8, opacity: 0 }}
                                                                                            animate={{ scale: 1, opacity: 1 }}
                                                                                            exit={{ scale: 0.8, opacity: 0 }}
                                                                                            transition={{ duration: 0.3 }}
                                                                                        >
                                                                                            {/* Cross Button */}
                                                                                            <button
                                                                                                onClick={() => setIsModalOpenForOTP(false)}
                                                                                                className="absolute top-2 right-2 p-2 rounded-full hover:bg-red-100 text-gray-500 hover:text-red-600 transition-all"
                                                                                            >
                                                                                                <X className="w-5 h-5" />
                                                                                            </button>

                                                                                            <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                                                                Please take OTP from Customer.
                                                                                            </p>

                                                                                            <div className="mt-1 px-6">
                                                                                                {/* OTP Input Boxes */}
                                                                                                <div className="flex justify-center items-center gap-2 mb-4">
                                                                                                    <p className="text-xs font-satoshi">OTP :</p>
                                                                                                    <input
                                                                                                        ref={inputRef}
                                                                                                        type="tel"
                                                                                                        inputMode="numeric"
                                                                                                        pattern="[0-9]*"
                                                                                                        value={otp}
                                                                                                        onChange={handleChange}
                                                                                                        maxLength={4}
                                                                                                        className="absolute opacity-0 h-0 w-0"
                                                                                                        autoFocus
                                                                                                    />
                                                                                                    {[...Array(4)].map((_, i) => (
                                                                                                        <div
                                                                                                            key={i}
                                                                                                            className="font-satoshi w-6 h-6 border border-gray-400 rounded-md flex items-center justify-center text-xs font-semibold"
                                                                                                        >
                                                                                                            {otp[i] || ""}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>

                                                                                                {alertMessage && (
                                                                                                    <div
                                                                                                        style={{ marginTop: "20px", fontSize: "12px", padding: "10px", borderRadius: '20px' }}
                                                                                                        className={`font-satoshi alert alert-${alertType} text-center`}
                                                                                                        role="alert"
                                                                                                    >
                                                                                                        {alertMessage}
                                                                                                    </div>
                                                                                                )}

                                                                                                {/* Done Button */}
                                                                                                <div className="flex gap-4">
                                                                                                    <button
                                                                                                        className="bg-[#21A6E9] flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                                        onClick={() => sendOTP(item)}
                                                                                                        disabled={otp.length !== 4 || buttonLoader[`${item}_reached`]}
                                                                                                    >
                                                                                                        {buttonLoader[`${item}_reached`] && (
                                                                                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                                        )}                                                                                                      
                                                                                                        Done
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </motion.div>
                                                                                    </motion.div>
                                                                                )}

                                                                            </AnimatePresence>
                                                                        </div>
                                                                    )}
                                                                    {/* 
                                                                    {(Boolean(item?.approvedRightlyMeasured != null && !item?.otpByCustomer)) && (<div
                                                                        className="flex justify-center items-center gap-2 mt-1 mb-3 cursor-text"
                                                                        onClick={handleClick}
                                                                    >
                                                                        <p className="text-xs font-satoshi">Take OTP:</p>
                                                                        <input
                                                                            ref={inputRef}
                                                                            type="text"
                                                                            value={otp}
                                                                            onChange={handleChange}
                                                                            maxLength={6}
                                                                            className="absolute opacity-0 pointer-events-none"
                                                                            autoFocus
                                                                        />
                                                                        {[...Array(6)].map((_, i) => (
                                                                            <div
                                                                                key={i}
                                                                                style={{ border: "1px solid black" }}
                                                                                className="font-satoshi w-5 h-5 border-1 mt-1 mb-2 border-gray-300 rounded-md flex items-center justify-center text-xs font-semibold"
                                                                            >
                                                                                {otp[i] || ""}
                                                                            </div>
                                                                        ))}
                                                                        <div className="flex gap-4">
                                                                            <button
                                                                                className="bg-green-700 flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                onClick={() => sendOTP(item)}
                                                                                disabled={otp.length !== 6 || buttonLoader[`${item}_reached`]}
                                                                            >
                                                                                {buttonLoader[`${item}_reached`] && (
                                                                                    <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                )}
                                                                              Done
                                                                            </button>


                                                                        </div>

                                                                    </div>)} */}

                                                                    {Boolean(
                                                                        item.otpByCustomer !== null &&
                                                                        item?.approvedRightlyMeasured && !item?.issue_occured
                                                                        &&  !item?.doneWorking

                                                                    ) && (
                                                                            <p
                                                                                onClick={() => { workDone(item) }}
                                                                                className="font-satoshi text-[11px] mt-1 bg-[#21A6E9] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                            >
                                                                                Job Done
                                                                                {/* <KeyboardDoubleArrowLeftIcon className="absolute right-2" /> */}
                                                                            </p>
                                                                        )}
                                                                    
                                                                    {Boolean(item?.doneWorking &&
                                                                        !item?.confirmDoneWorking &&
                                                                        !item?.issue_occured) && (
                                                                            <button
                                                                                disabled
                                                                                className="fixed bottom-0 font-satoshi text-[11px] mt-1 bg-gray-400 px-4 py-3 text-sm border border-gray-400 text-center rounded-full font-bold text-white flex items-center justify-center relative w-full opacity-70 cursor-not-allowed"
                                                                            >
                                                                                Waiting for customer to confirm job completion...
                                                                            </button>
                                                                    )}

                                                                    {item?.issue_occured && (
                                                                        <>
                                                                            {/* Trigger Button */}
                                                                            <div className="flex justify-end my-2">
                                                                                <button
                                                                                    onClick={() => setIsIssueModalOpen(true)}
                                                                                    className="font-satoshi text-[11px] mt-1 bg-[#EE3840] px-4 py-3 text-sm border border-blue-500 text-center rounded-full font-bold text-white flex items-center justify-center relative cursor-pointer w-full"
                                                                                >
                                                                                    Issue Raised
                                                                                </button>
                                                                            </div>

                                                                            {/* Modal with Framer Motion */}
                                                                            <AnimatePresence>
                                                                                {isIssueModalOpen && (
                                                                                    <motion.div
                                                                                        className="fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-50"
                                                                                        initial={{ opacity: 0 }}
                                                                                        animate={{ opacity: 1 }}
                                                                                        exit={{ opacity: 0 }}
                                                                                    >
                                                                                        <motion.div
                                                                                            className="bg-white p-6 rounded-2xl shadow-2xl w-[90%] max-w-sm text-center relative"
                                                                                            initial={{ scale: 0.8, opacity: 0 }}
                                                                                            animate={{ scale: 1, opacity: 1 }}
                                                                                            exit={{ scale: 0.8, opacity: 0 }}
                                                                                            transition={{ duration: 0.3 }}
                                                                                        >
                                                                                            {/* Close Button */}
                                                                                            <button
                                                                                                onClick={() => setIsIssueModalOpen(false)}
                                                                                                className="absolute top-2 right-2 text-gray-400 hover:text-red-500"
                                                                                            >
                                                                                                <X className="w-5 h-5" />
                                                                                            </button>

                                                                                            {/* Alert Icon */}
                                                                                            <div className="flex justify-center mb-3">
                                                                                                <div className="bg-red-100 p-3 rounded-full">
                                                                                                    <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        className="h-6 w-6 text-red-600"
                                                                                                        fill="none"
                                                                                                        viewBox="0 0 24 24"
                                                                                                        stroke="currentColor"
                                                                                                    >
                                                                                                        <path
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                            strokeWidth={2}
                                                                                                            d="M12 9v2m0 4h.01M4.93 4.93l14.14 14.14M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
                                                                                                        />
                                                                                                    </svg>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Issue Message */}
                                                                                            <p className="font-satoshi text-sm font-semibold text-gray-800 mb-2">
                                                                                                {item.issue_occured}
                                                                                            </p>

                                                                                            {/* Phone Call Button */}
                                                                                            <button
                                                                                                className="font-satoshi flex items-center justify-center mx-auto mt-4 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full transition duration-300"
                                                                                                onClick={() => (window.location.href = 'tel:+917800784700')}
                                                                                            >
                                                                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon6.svg' alt="Call" className="h-5 w-5 mr-2" />
                                                                                                Call Support
                                                                                            </button>
                                                                                        </motion.div>
                                                                                    </motion.div>
                                                                                )}
                                                                            </AnimatePresence>
                                                                        </>
                                                                    )}



                                                                </div>
                                                            </div>

                                                            {alertMessage && (
                                                                <div style={{ fontSize: "15px", padding: "10px" }} className={`alert  ${alertType == "success" ? "text-green-500" : "text-red-500"} font-satoshi text-center`} role="alert">
                                                                    {alertMessage}
                                                                </div>
                                                            )}


                                                            {isCancelContainerVisible && (
                                                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] mt-[40px]">
                                                                    <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                                                        <h6 className="m-0 font-[700]  text-[30px] font-satoshi text-center text-[#000000]">Drop Case Procedure</h6>
                                                                        <img onClick={(e) => {
                                                                            setIsCancelContainerVisible(false)
                                                                            setReasonsForDrop(false)
                                                                            setSelectedReasons([])
                                                                            setOtherReason('')
                                                                        }}
                                                                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[48px] w-[48px]' alt="" />
                                                                        <div>
                                                                            {reasonsForDrop == false && (
                                                                                <div>
                                                                                    <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect crane service!!! </p>
                                                                                    <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out for ❓ 🤔 </p>
                                                                                    <div className=" grid md:grid-cols-2 grid-cols-1 pt-[40px] items-center gap-[18px] ">
                                                                                        <div
                                                                                            onClick={(e) => {
                                                                                                setReasonsForDrop(false)
                                                                                                setIsCancelContainerVisible(false)
                                                                                                setSelectedReasons([])
                                                                                                setOtherReason('')
                                                                                            }}
                                                                                            className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                                                                                            <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Don't Drop</button>
                                                                                            {/* <img src={rightarrow} className='h-[30px] w-[30px]' alt="" /> */}
                                                                                        </div>
                                                                                        <div onClick={() => setReasonsForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                                            <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Drop Case</button>
                                                                                            {/* <img src={rightarrow} className='h-[30px] w-[30px]' alt="" /> */}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)}

                                                                            {reasonsForDrop == true && (
                                                                                <div>
                                                                                    <div>
                                                                                        <div>

                                                                                            <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                                                {reasons.map((reason) => (
                                                                                                    <button
                                                                                                        key={reason}
                                                                                                        onClick={() => handleSelectReason(reason)}
                                                                                                        style={{
                                                                                                            fontSize: '16px',
                                                                                                            display: "flex",
                                                                                                            justifyContent: "center",
                                                                                                            alignItems: "center",
                                                                                                            padding: "15px",
                                                                                                            borderRadius: "20px",
                                                                                                            backgroundColor: selectedReasons.includes(reason) ? "#21A6E9" : "white",
                                                                                                            color: selectedReasons.includes(reason) ? "white" : "black",

                                                                                                            border: "1px solid #21A6E9",
                                                                                                            cursor: "pointer",
                                                                                                            boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                                                        }}
                                                                                                    >
                                                                                                        {reason}
                                                                                                    </button>
                                                                                                ))}
                                                                                            </div>


                                                                                            <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                                                                <p style={{ textAlign: "left", fontSize: '16px' }}> Other Reason  : </p>
                                                                                                <textarea
                                                                                                    style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                                                            </label>

                                                                                            {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                                                                            <div className='pb-10'>
                                                                                                {isLoading && (
                                                                                                    <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                                                        <ClipLoader color="black" loading={isLoading} />
                                                                                                        <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                                                                                    </div>
                                                                                                )}
                                                                                                {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                                                                    You have already Cancelled Case !!!
                                                                                                </div>)}
                                                                                                {alertInfo.show && (
                                                                                                    <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                                                        {alertInfo.message}
                                                                                                    </Alert>
                                                                                                )}

                                                                                                <div onClick={(e) => { cancelingOrder(currentItem) }} disabled={isLoading} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Drop Case</button>
                                                                                                    {/* <img src={rightarrow} className='h-[30px] w-[30px]' alt="" /> */}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            )}


                                                        </div>
                                                    </div>
                                                </>
                                            )

                                        })()}
                                    </div>
                                )}
                            </div>
                        </motion.div>
                    </div>
                )}
                {data.length === 0 && doneFetching && (
                    <div>
                        <NoDataFound />
                    </div>
                )}


                {TaskCompletedDone && (<SuccessMessage />)}






                {/* Modal */}
                {/* <ModalForWaiting
                isOpen={isModalWaitingProp}
                onClose={() => setIsModalWaiting(false)}
            /> */}
            </div>


        </>
    )
}

export default VendorDriverAllotedCase;